/**************************************************
 * Nombre:       Tarjeta_Funnel
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {TEXTO} from "../../Modulo_Dashboard/ContantesColor";
import {BarChartOutlined, OpenInNew} from '@mui/icons-material'
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Detalle_Campana from "../Dialogos/Dialogo_Detalle_Campana";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {irUrl} from "../../Utilidades/irUrl";
import {URLPAGINA} from "../../Constantes";
import dayjs from "dayjs";

const Tarjeta_Funnel = ({item, campanas, realizado}) => {
    const navigate = useNavigate();
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Detalle_Campana,
        titulo: 'Detalles de Campaña',
        realizado: realizado
    })
    const [campana, setCampana] = useState({})
    const [hayCampana, setHayCampana] = useState(false)

    useEffect(() => {


        let cam = campanas.filter((campa) => campa.idFunnel === item.id)
        if (cam && cam[0]) {
            setCampana(cam[0])
            setHayCampana(true)
        } else {
            setHayCampana(false)
        }

    }, [campanas])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 1,
                border: 1,
                borderColor: theme.palette.primary.main + 30

            }}
        >

            <Dialogo/>

            <Grid container size={4} sx={{justifyContent: 'flex-start', p: 1, zIndex: 2}}>
                <Typography sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: '#fff',
                    px: 1.5,
                    borderRadius: 4,
                    fontSize: 12
                }}>{campana && campana.estado}

                </Typography>
            </Grid>

            {campana.fechaFin > 0 && hayCampana &&
                <Grid container size={8} sx={{justifyContent: 'flex-end', p: 1, zIndex: 2}}>
                    <Typography sx={{
                        backgroundColor: theme.palette.primary.main,
                        color: '#fff',
                        px: 1.5,
                        borderRadius: 4,
                        fontSize: 12
                    }}>Hasta {dayjs(campana.fechaFin).format('DD/MM/YY')}
                    </Typography>
                </Grid>
            }

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: hayCampana ? -5 : -3, zIndex: 1}}>
                <img src={item.img} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    px: 2,
                    py: 1
                }}
                spacing={1}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Typography sx={{fontWeight: 300, fontSize: 12, lineHeight: 1.2}}>{item.descripcion}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Button
                        onClick={() => irUrl(URLPAGINA + '?id=' + item.id + '&idUsu=admin_gmail-com')}
                        startIcon={<OpenInNew/>} variant={'outlined'} fullWidth sx={{borderRadius: 1}}>Ver</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Button
                        disabled={hayCampana}
                        onClick={() => abrir({
                            img: item.img,
                            nombreFunnel: item.nombre,
                            descripcion: item.descripcion,
                            idFunnel: item.id
                        })}
                        fullWidth sx={{borderRadius: 1}}>Activar</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0, mb: 1}}>
                    <Button
                        onClick={() => navigate('/Resultados/' + campana.id + '/' + item.id)}
                        startIcon={<BarChartOutlined/>} color={hayCampana ? 'primary' : 'secondary'}
                        variant={hayCampana ? 'contained' : 'outlined'} fullWidth
                        sx={{
                            borderRadius: 1,
                            borderColor: hayCampana ? 'inerent' : TEXTO + 90,
                            color: hayCampana ? 'inerent' : TEXTO
                        }}>Ver Resultados</Button>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Funnel    